<template>
  <div
    v-if="barChartOptions"
    class="multi-bar"
    :class="{ 'multi-bar--dark': dark }"
    style="position: unset;"
  >
    <h3 v-if="label" class="multi-bar__title">{{ label }}</h3>
    <VueApexCharts
      name="name"
      type="bar"
      width="100%"
      height="350px"
      :options="barChartOptions"
      :series="series"
    >
    </VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

export default {
  name: "MultiBar",
  components: {
    VueApexCharts
  },
  props: {
    label: {
      type: String
    },
    name: {
      type: String
    },
    xAxisLabel: {
      type: String
    },
    yAxisLabel: {
      type: String
    },
    datum: {
      type: Array
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      series: null,
      barChartOptions: null
    };
  },
  watch: {
    dark() {
      this.applyChartData();
    },
    datum: {
      deep: true,
      handler() {
        this.applyChartData();
      }
    }
  },
  created() {
    this.applyChartData();
  },
  methods: {
    applyChartData() {
      if (!this.datum || !this.datum[0] || !this.datum[1]) {
        this.series = null;
        this.barChartOptions = null;
        return;
      }
      this.series = [
        {
          name: this.datum[0].key,
          data: this.datum[0].values,
          color: this.datum[0].color
        },
        {
          name: this.datum[1].key,
          data: this.datum[1].values,
          color: this.datum[1].color
        }
      ];
      this.barChartOptions = this.buildOptions();
    },
    buildOptions() {
      const labelColor = this.dark ? "#b0bec5" : undefined;
      const gridColor = this.dark ? "rgba(255, 255, 255, 0.08)" : undefined;

      return {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false
          },
          ...(this.dark
            ? {
                foreColor: "#eceff1",
                background: "transparent"
              }
            : {})
        },
        theme: {
          mode: this.dark ? "dark" : "light"
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"]
        },
        grid: {
          ...(gridColor ? { borderColor: gridColor } : {})
        },
        xaxis: {
          tickAmount: 6,
          labels: {
            formatter: function(val) {
              if (!val || val.length < 7) return val;
              const datePart = String(val).split(" ")[0];
              const splitDate = datePart.split("/");
              if (splitDate.length !== 3) return val;
              const year =
                splitDate[2].length === 2 ? "20" + splitDate[2] : splitDate[2];
              const date = year + "-" + splitDate[1] + "-" + splitDate[0];
              return moment(new Date(date)).format("DD/MM/YY");
            },
            rotate: -45,
            ...(labelColor ? { style: { colors: labelColor } } : {})
          }
        },
        yaxis: {
          title: {
            text: this.yAxisLabel,
            ...(labelColor ? { style: { color: labelColor } } : {})
          },
          labels: {
            ...(labelColor ? { style: { colors: labelColor } } : {})
          }
        },
        fill: {
          opacity: 1
        },
        ...(this.dark
          ? {
              legend: {
                labels: { colors: "#e0e0e0" }
              }
            }
          : {}),
        tooltip: {
          theme: this.dark ? "dark" : "light",
          y: {
            formatter: function(val) {
              return val;
            }
          }
        }
      };
    },
    formatValue(value, max) {
      let valor_formatado = value;
      valor_formatado = (value * 100) / max;
      return valor_formatado;
    }
  }
};
</script>

<style lang="scss" scoped>
.multi-bar__title {
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.multi-bar--dark .multi-bar__title {
  color: rgba(255, 255, 255, 0.87);
}
</style>
